import { flow, toPairs, reduce } from 'lodash/fp';
import valuesById from './valuesById';

export default flow(
  toPairs,
  reduce((acc, [id, value]) => {
    const ids = acc[value] || [];

    return { ...acc, [value]: [...ids, id] };
  }, {}),
)(valuesById);
